<template>
  <div :class="['c-footer__brands', { 'c-footer__brands--is-active': isActive }]">
    <div class="c-footer__brands-body">
      <transition name="slide-down" mode="out-in">
        <div class="c-footer__brands-icons" @click="expand()" v-if="!isActive" key="collapsed">
          <svg class="icon icon-slots"><use xlink:href="#icon-slots"></use></svg>
          <svg class="icon icon-videoslots"><use xlink:href="#icon-videoslots"></use></svg>
          <svg class="icon icon-blackjack"><use xlink:href="#icon-blackjack"></use></svg>
          <svg class="icon icon-roulette"><use xlink:href="#icon-roulette"></use></svg>
          <svg class="icon icon-poker"><use xlink:href="#icon-poker"></use></svg>
          <svg class="icon icon-bingo"><use xlink:href="#icon-bingo"></use></svg>
          <svg class="icon icon-sports"><use xlink:href="#icon-sports"></use></svg>
          <svg class="icon icon-games"><use xlink:href="#icon-games"></use></svg>
        </div>
        <div class="c-footer__brands-content" v-if="isActive" key="expanded">
          <h5 class="visible-xs visible-sm" @click="collapse()">{{ $speak('app.components.FooterBar.part_of_casinoeu') }}</h5>

          <a class="c-footer__brands-item" :href="gameTypeUrls.slots">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/slots-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.videoslots">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/videoslots-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.blackjack">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/blackjack-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.roulette">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/roulette-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.poker">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/poker-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.bingo">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/bingo-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.sports">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/sports-logo.svg')"></div>
          </a>

          <a class="c-footer__brands-item" :href="gameTypeUrls.games">
            <div class="c-logo--inversed" v-html="require('!!svg-inline-loader!^/logos/games-logo.svg')"></div>
          </a>

          <svg class="icon icon-white icon-chevron-up c-footer__brands-collapse visible-xs visible-sm" @click="collapse()"><use xlink:href="#icon-chevron-up"></use></svg>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  // Utilities
  import { debounce } from '@/utilities';

  export default {
    name: 'FooterBrands',

    data () {
      return {
        isActive: true,
        gameTypeUrls: Laravel.gameTypeUrls
      }
    },

    methods: {
      expand () {
        this.isActive = true;
      },

      collapse () {
        this.isActive = false;
      },

      checkState () {
        this.isActive = this.$mq('md-min') ? true : false;
      }
    },

    created () {
      this.checkState();

      if (this.$mq('md-min')) window.addEventListener('resize', debounce(this.checkState, 250));
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/FooterBrands.vue